// ---------------------------------------------------------

import Block from '@components/block';

// ---------------------------------------------------------

const RenderBlocks = (blocks = [], { markFirstBlockAsH1 = false } = {}) => {
  return (blocks || [])
    .filter((block) => block !== null)
    .map((block, idx) => {
      return (
        <Block
          key={idx}
          template={block?.__typename}
          {...block}
          isFirstBlock={markFirstBlockAsH1 && idx === 0}
        />
      );
    });
};

export default RenderBlocks;
